/**
 * SubscriptionSuccessPage Component
 * 
 * Success page shown after completing Stripe checkout.
 * NOTE: Behavior copied from legacy App.js, do not change without regression testing.
 * 
 * @component
 * @param {Object} props
 * @param {string} props.sessionId - Stripe session ID
 * @param {Function} props.onContinue - Callback to continue to dashboard
 */

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../../utils/constants';

function SubscriptionSuccessPage({ sessionId, onContinue }) {
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const verifySession = async () => {
      try {
        await axios.post(`${API}/subscription/verify-session`, { session_id: sessionId });
        setVerifying(false);
        toast.success('Subscription activated successfully!');
      } catch (error) {
        console.error('Session verification failed:', error);
        toast.error('Failed to verify subscription. Please contact support.');
        setVerifying(false);
      }
    };

    if (sessionId) {
      verifySession();
    } else {
      setVerifying(false);
    }
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        {verifying ? (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Verifying Payment...</h2>
            <p className="text-gray-600">Please wait while we confirm your subscription.</p>
          </>
        ) : (
          <>
            <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Successful!</h2>
            <p className="text-gray-600 mb-6">Your subscription has been activated. Welcome to CaterLog!</p>
            <button
              onClick={onContinue}
              className="btn-bawarchi-primary w-full"
            >
              Continue to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default SubscriptionSuccessPage;